<template>
  <div style="padding: 24px;background-color: #fff;">
    <p v-html="eventInfo.eventApplyNotice" style="padding-bottom: 80px"></p>
    <div class="nextBox">
        <a-radio v-model="isSee" :checked="isSee">我已阅读并知悉以上内容</a-radio>
        <a-button type="primary" @click="goPageFn">下一步</a-button>
    </div>
  </div>
</template>
<script>
import { getAction } from "@/api/manage";
export default {
  name: '',
  components: {},
  data() {
    return {
        eventInfo:{},
        isSee:false,
    }
  },
  created() {this.init(this.$route.query.id)},
  mounted() {},
  methods: {
    init(eventId){
         getAction('/teaching/teachingEvent/queryById', { id: eventId }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result
        } else {
          this.$message.warning('找不到报名的活动')
        }
      })
    },
    goPageFn(){
        if(!this.isSee){
            this.$message.error('请勾选左侧阅读须知')
            return
        }
        let query = this.$route.query
        this.$router.push({path: '/event/apply', query:{id: query.id, agentCode: query.agentCode}})
    }
   
  }
}
</script>
<style lang='scss' scoped>
.nextBox{
    width: 100%;
    height: 60px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9;
    box-shadow: 0px -3px 4px 0px rgba(0,0,0,0.04);
    background: #fff;
}
</style>
